/**
 * PayNow icon URL
 * Singapore's national real-time payment system
 * Used for payment method selection UI
 */
export const PAYNOW_ICON_DATA_URL =
  'https://images.ctfassets.net/c3n7jozh84hr/2A5qlS6JkUsOyFVPzQ0KlK/22b497afd71030ef1a44a52394b15027/______2022-06-30_11.03.43.png';
